export function isMobileDevice() {
  const ua = navigator.userAgent || ''
  const mobileUa = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i.test(ua)
  const iPad = /iPad/i.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  const userAgentMobile = Boolean(navigator.userAgentData?.mobile)
  const coarsePointer = window.matchMedia?.('(pointer: coarse)').matches ?? false
  const narrowViewport = window.matchMedia?.('(max-width: 767px)').matches ?? window.innerWidth <= 767
  return mobileUa || iPad || userAgentMobile || (coarsePointer && narrowViewport)
}

export function getOsPlatform() {
  const ua = navigator.userAgent || ''
  const uaDataPlatform = String(navigator.userAgentData?.platform || '').toLowerCase()
  if (/android/i.test(ua) || uaDataPlatform === 'android') return 'android'
  if (
    /iPhone|iPad|iPod/i.test(ua) ||
    uaDataPlatform === 'ios' ||
    (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1)
  ) {
    return 'ios'
  }
  return 'desktop'
}
